var _defs, _ellipse, _text, _ellipse2, _text2, _ellipse3, _text3, _ellipse4, _text4, _ellipse5, _text5, _ellipse6, _text6, _path, _path2, _path3, _path4, _rect, _text7, _switch;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraphdrawio4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "391px",
    height: "231px",
    viewBox: "-0.5 -0.5 391 231",
    className: "ge-export-svg-dark",
    content: "<mxfile host=\"Electron\" modified=\"2024-02-10T11:38:20.192Z\" agent=\"Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) draw.io/22.1.16 Chrome/120.0.6099.109 Electron/28.1.0 Safari/537.36\" etag=\"YrVKi6R_1IjH6xudijzy\" version=\"22.1.16\" type=\"device\"><diagram name=\"Page-1\" id=\"beBrEWIuwQJhH1_dIsJB\">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</diagram></mxfile>",
    style: {
      backgroundColor: "rgb(24, 20, 29)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "svg.ge-export-svg-dark &gt; * { filter: invert(100%) hue-rotate(180deg); }&#xa;svg.ge-export-svg-dark image { filter: invert(100%) hue-rotate(180deg) }"))), /*#__PURE__*/React.createElement("g", null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90,
    cy: 50,
    rx: 20,
    ry: 20,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 50,
      marginLeft: 71
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "1")))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 54,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "1")))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 310,
    cy: 190,
    rx: 20,
    ry: 20,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 190,
      marginLeft: 291
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "6")))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 310,
    y: 194,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "6")))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 370,
    cy: 100,
    rx: 20,
    ry: 20,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 100,
      marginLeft: 351
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "5")))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 370,
    y: 104,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "5")))), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 170,
    cy: 140,
    rx: 20,
    ry: 20,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 140,
      marginLeft: 151
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "3")))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 144,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "3")))), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20,
    cy: 140,
    rx: 20,
    ry: 20,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 140,
      marginLeft: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "2")))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 144,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "2")))), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 310,
    cy: 20,
    rx: 20,
    ry: 20,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 20,
      marginLeft: 291
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "4")))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 310,
    y: 24,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "4")))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 79.9 65.97 L 76.25 68.94 L 73.58 70.84 L 70.62 72.66 L 67.31 74.49 L 63.7 76.31 L 59.93 78.12 L 56.34 79.78 L 52.83 81.38 L 49.22 83.08 L 45.72 84.89 L 42.43 86.79 L 39.49 88.84 L 36.79 91.13 L 34.39 93.6 L 32.31 96.12 L 30.64 98.53 L 29.64 100.7 L 29.04 102.8 L 28.67 104.83 L 28.47 106.67 L 28.31 109.53 L 28.35 111.79 L 28.44 113.69 L 28.54 116.14 L 28.58 118.71 L 28.49 119.26 L 28.23 119.75 L 27.83 120.13 L 27.32 120.36 L 26.77 120.42 L 26.23 120.3 L 25.75 120.02 L 25.4 119.6 L 25.19 119.08 L 25.16 118.52 L 25.31 117.99 L 25.62 117.53 L 26.06 117.2 L 26.59 117.02 L 27.14 117.02 L 27.67 117.2 L 28.11 117.53 L 28.42 117.99 L 28.56 118.52 L 28.54 119.08 L 28.33 119.6 L 27.97 120.02 L 27.5 120.3 L 26.96 120.42 L 26.4 120.36 L 25.9 120.13 L 25.49 119.75 L 25.24 119.26 L 25.15 118.71 L 25.15 118.71 L 25.18 116.14 L 25.3 113.68 L 25.4 111.74 L 25.59 109.27 L 26.04 106.29 L 26.42 104.34 L 26.98 102.12 L 27.84 99.8 L 29.13 97.44 L 30.96 94.99 L 33.15 92.39 L 35.67 89.8 L 38.49 87.43 L 41.56 85.28 L 44.93 83.35 L 48.47 81.51 L 52.11 79.78 L 55.6 78.18 L 59.16 76.51 L 62.89 74.7 L 66.42 72.89 L 69.63 71.09 L 72.47 69.26 L 75.04 67.48 L 78.65 64.45 L 78.85 64.32 L 79.07 64.25 L 79.31 64.22 L 79.54 64.26 L 79.76 64.35 L 79.95 64.49 L 80.1 64.67 L 80.21 64.89 L 80.26 65.12 L 80.25 65.36 L 80.18 65.58 L 80.07 65.79 L 79.9 65.97 L 79.9 65.97",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 108.67 57.99 L 110.15 58.59 L 112.11 59.46 L 114.64 60.88 L 116.16 61.98 L 117.73 63.2 L 119.44 64.66 L 121.15 66.27 L 122.95 68.09 L 124.75 70.11 L 126.64 72.45 L 128.56 74.84 L 130.41 77.21 L 132.15 79.69 L 133.68 82.1 L 135.17 84.57 L 136.56 87.13 L 137.84 89.72 L 138.95 92.12 L 139.82 94.41 L 140.59 96.72 L 141.29 98.94 L 141.99 101.16 L 142.69 103.39 L 143.39 105.51 L 144.13 107.7 L 144.82 109.84 L 145.58 112 L 146.4 114.14 L 147.25 116.24 L 148.03 118.24 L 148.78 120 L 149.53 121.7 L 150.67 124.4 L 150.73 124.73 L 150.68 125.07 L 150.53 125.37 L 150.29 125.62 L 149.98 125.77 L 149.65 125.81 L 149.31 125.74 L 149.01 125.57 L 148.79 125.32 L 148.66 125.01 L 148.63 124.67 L 148.72 124.33 L 148.9 124.05 L 149.17 123.84 L 149.49 123.72 L 149.83 123.72 L 150.16 123.82 L 150.43 124.02 L 150.63 124.3 L 150.72 124.63 L 150.71 124.97 L 150.59 125.28 L 150.38 125.54 L 150.09 125.73 L 149.76 125.81 L 149.42 125.77 L 149.11 125.64 L 148.86 125.41 L 148.69 125.12 L 148.69 125.12 L 147.7 122.47 L 146.99 120.71 L 146.3 118.9 L 145.57 116.91 L 144.72 114.79 L 143.89 112.59 L 143.1 110.37 L 142.46 108.26 L 141.73 106.05 L 141.06 103.89 L 140.39 101.65 L 139.73 99.41 L 139.1 97.2 L 138.39 94.92 L 137.64 92.71 L 136.57 90.36 L 135.3 87.82 L 133.93 85.33 L 132.43 82.91 L 130.9 80.58 L 129.17 78.2 L 127.28 75.9 L 125.3 73.59 L 123.36 71.41 L 121.53 69.57 L 119.69 67.91 L 117.98 66.45 L 116.27 65.12 L 114.73 63.98 L 113.34 63.01 L 111.04 61.62 L 109.28 60.66 L 107.81 60.01 L 107.59 59.88 L 107.4 59.69 L 107.25 59.47 L 107.17 59.22 L 107.15 58.96 L 107.19 58.7 L 107.29 58.45 L 107.45 58.24 L 107.65 58.08 L 107.89 57.96 L 108.15 57.91 L 108.42 57.92 L 108.67 57.99 L 108.67 57.99",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 39.28 136.49 L 41.2 136.5 L 43.81 136.43 L 45.27 136.4 L 46.82 136.44 L 48.38 136.5 L 50.19 136.64 L 52.11 136.82 L 54.1 137.01 L 56.23 137.22 L 58.56 137.45 L 61.09 137.69 L 63.68 137.88 L 66.51 138.05 L 69.39 138.14 L 72.6 138.2 L 76.09 138.23 L 80.15 138.26 L 84.7 138.27 L 89.52 138.28 L 94.49 138.34 L 99.43 138.42 L 104.25 138.5 L 108.79 138.64 L 112.96 138.79 L 116.41 138.96 L 119.48 139.18 L 122.18 139.42 L 124.66 139.59 L 126.81 139.72 L 128.72 139.83 L 130.49 139.95 L 132.17 140.07 L 133.85 140.2 L 136.29 140.32 L 138.61 140.42 L 140.02 140.53 L 142.67 140.69 L 145.44 140.85 L 148.39 141.09 L 148.81 141.18 L 149.16 141.4 L 149.43 141.72 L 149.59 142.12 L 149.61 142.54 L 149.5 142.95 L 149.26 143.29 L 148.92 143.55 L 148.52 143.68 L 148.09 143.68 L 147.69 143.54 L 147.36 143.29 L 147.12 142.94 L 147.01 142.53 L 147.03 142.11 L 147.2 141.72 L 147.47 141.39 L 147.84 141.18 L 148.25 141.09 L 148.67 141.14 L 149.05 141.31 L 149.35 141.61 L 149.55 141.98 L 149.62 142.4 L 149.55 142.81 L 149.35 143.19 L 149.04 143.48 L 148.66 143.65 L 148.24 143.7 L 148.24 143.7 L 145.25 143.43 L 143.81 143.31 L 141.13 143.09 L 138.44 142.79 L 136.09 142.53 L 133.63 142.2 L 131.99 141.98 L 130.3 141.76 L 128.56 141.52 L 126.68 141.29 L 124.54 141.04 L 122.05 140.81 L 119.38 140.56 L 116.35 140.35 L 112.9 140.18 L 108.76 140.03 L 104.23 139.9 L 99.4 139.82 L 94.48 139.76 L 89.52 139.72 L 84.7 139.73 L 80.15 139.74 L 76.09 139.75 L 72.59 139.77 L 69.36 139.79 L 66.46 139.8 L 63.59 139.77 L 60.96 139.71 L 58.41 139.61 L 56.06 139.49 L 53.9 139.36 L 51.91 139.23 L 50.01 139.1 L 48.25 138.98 L 46.74 138.9 L 45.27 138.84 L 43.81 138.82 L 41.2 138.75 L 39.28 138.75 L 39 138.72 L 38.76 138.62 L 38.52 138.47 L 38.34 138.26 L 38.22 138.02 L 38.15 137.76 L 38.15 137.48 L 38.22 137.22 L 38.34 136.98 L 38.52 136.78 L 38.76 136.62 L 39 136.52 L 39.28 136.49 L 39.28 136.49",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 324.38 32.24 L 325.44 34.12 L 326.98 36.35 L 327.83 37.59 L 328.73 38.83 L 329.67 40.17 L 330.66 41.57 L 331.74 43.11 L 332.9 44.85 L 334.18 46.66 L 335.51 48.48 L 336.84 50.18 L 338.28 52.02 L 339.73 53.85 L 341.11 55.69 L 342.35 57.36 L 343.49 58.84 L 344.5 60.22 L 345.49 61.59 L 346.47 62.95 L 347.36 64.3 L 348.24 65.66 L 349.17 66.91 L 350.21 68.29 L 351.26 69.68 L 352.26 71.01 L 353.2 72.27 L 354.1 73.5 L 355.68 75.53 L 356.91 77.27 L 357.87 78.69 L 358.71 80.16 L 359.92 82.28 L 360.07 82.72 L 360.07 83.18 L 359.93 83.63 L 359.65 84 L 359.27 84.27 L 358.82 84.4 L 358.35 84.38 L 357.92 84.21 L 357.56 83.91 L 357.32 83.51 L 357.21 83.06 L 357.26 82.6 L 357.45 82.17 L 357.77 81.83 L 358.17 81.61 L 358.63 81.53 L 359.1 81.6 L 359.51 81.81 L 359.83 82.14 L 360.03 82.57 L 360.09 83.03 L 360 83.48 L 359.76 83.89 L 359.41 84.19 L 358.97 84.37 L 358.51 84.4 L 358.06 84.28 L 357.67 84.02 L 357.38 83.66 L 357.38 83.66 L 355.87 80.8 L 355.12 79.44 L 354.21 77.94 L 352.93 76.07 L 352.12 74.93 L 351.25 73.69 L 350.35 72.43 L 349.37 71.09 L 348.34 69.7 L 347.27 68.28 L 346.29 66.89 L 345.45 65.53 L 344.64 64.21 L 343.71 62.82 L 342.78 61.43 L 341.86 60.05 L 340.76 58.53 L 339.55 56.87 L 338.2 55.09 L 336.71 53.29 L 335.2 51.5 L 333.79 49.77 L 332.39 47.98 L 330.99 46.16 L 329.81 44.51 L 328.68 42.96 L 327.68 41.55 L 326.77 40.22 L 325.86 38.91 L 325.05 37.66 L 324.25 36.42 L 323.54 35.21 L 322.44 33.35 L 322.34 33.1 L 322.3 32.84 L 322.32 32.57 L 322.4 32.31 L 322.55 32.08 L 322.74 31.9 L 322.98 31.76 L 323.24 31.69 L 323.51 31.68 L 323.77 31.73 L 324.01 31.85 L 324.22 32.02 L 324.38 32.24 L 324.38 32.24",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 200,
    width: 60,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 215,
      marginLeft: 115
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "RES:2")))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 115,
    y: 219,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "RES:2"))))), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", {
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }), /*#__PURE__*/React.createElement("a", {
    transform: "translate(0,-5)",
    xlinkHref: "https://www.drawio.com/doc/faq/svg-export-text-problems",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    fontSize: "10px",
    x: "50%",
    y: "100%"
  }, "Text is not SVG - cannot display")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphdrawio4);
export default __webpack_public_path__ + "static/media/graph.drawio4.e318c90ea191fce9470886179ea383b0.svg";
export { ForwardRef as ReactComponent };